import { Switch, SwitchProps } from '@stereograph/teia-system-design/components/Switch';

export const TeiaQuantityTakeoffTableHeadAggregateItem = (props: SwitchProps) => {
  return <Switch {...props} />;
};
